import React from 'react'
import { Spin, Alert, Button } from 'antd'
import AssessmentPanel from './AssessmentPanel'
import { PopUp, PopUpMessage, PopUpButtonContainer, Wrapper } from './index.styled'
import PatientProfilePanel from './PatientProfilePanel'
import PatientReportPanel from './PatientReportPanel'
import { useCurrentPatient } from './useCurrentPatient'
import { currentPatientAsync, resetCurrentPatientStatus } from '../../../redux/flows/portal/currentPatient'
import { setCurrentVisit } from '../../../redux/flows/portal/lobby'
import { useAppDispatch, useAppSelector } from '../../../redux/store'
import { APIStatus } from '../../../redux/types'

export default function CurrentPatientScreen() {
  const {
    currentPatientStatus,
    currentVisit,
    currentPatientError,
    undoVisitError,
    handleRetry,
    handleUndoVisit,
    isRetryDisabled,
  } = useCurrentPatient()

  if (currentPatientStatus === APIStatus.pending) {
    return (
      <Wrapper>
        <div
          style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '851px' }}
        >
          <Spin />
        </div>
      </Wrapper>
    )
  }

  if (currentPatientStatus === APIStatus.rejected && currentVisit) {
    return (
      <Wrapper>
        <PopUp open={true} centered mask={true} maskClosable={true} footer={null} closable={false}>
          <PopUpMessage>
            {currentPatientError
              ? 'Failed to load patient details'
              : undoVisitError
                ? 'Failed to undo visit'
                : 'Error Occurred'}
          </PopUpMessage>
          <PopUpButtonContainer>
            {!isRetryDisabled && (
              <Button
                children={'Retry'}
                style={{
                  width: 89,
                  height: 38,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  background: '#007f7c',
                  color: 'var(--color-text-secondary)',
                }}
                onClick={handleRetry}
              ></Button>
            )}
            <Button
              children={'Undo'}
              style={{
                width: 89,
                height: 38,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: '#007f7c',
                border: '1px solid #007f7c',
                background: 'transparent',
              }}
              onClick={handleUndoVisit}
            ></Button>
          </PopUpButtonContainer>
        </PopUp>
      </Wrapper>
    )
  }

  return (
    <Wrapper>
      <PatientProfilePanel />

      <AssessmentPanel />

      <PatientReportPanel />
    </Wrapper>
  )
}
